import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const APP_STORE_URL = "https://apps.apple.com/us/app/nisaa/id6772802488";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const navLinks = [
    { name: 'Features', href: isHome ? '#features' : '/#features' },
    { name: 'Privacy', href: isHome ? '#privacy' : '/#privacy' },
    { name: 'Disclaimers', href: '/disclaimer' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-line/80 glass-header">
      <nav className="w-full max-w-[1120px] mx-auto px-4 min-h-[68px] flex items-center justify-between gap-5 lg:flex-row flex-col lg:py-0 py-4">
        <div className="flex items-center justify-between w-full lg:w-auto">
          <Link to="/" className="inline-flex items-center gap-2.5 text-aubergine font-extrabold text-xl">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/cb626cea481d7a3becbea24c974d0b65e32a5ba3c552e12f2d9768775a77545899023c8e9d705cdece5224b19de37c3e/images/aW1hZ2UvcG5n/28fdf0d31b0c078de194e2b67a8e085a.png" 
              alt="Nisaa Logo" 
              className="w-[34px] h-[34px] rounded-lg object-cover" 
            />
            <span>Nisaa</span>
          </Link>
          <button 
            className="lg:hidden text-aubergine p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <SafeIcon name={isMenuOpen ? "X" : "Menu"} className="w-6 h-6" />
          </button>
        </div>

        <div className={`lg:flex items-center gap-[28px] text-muted text-[0.94rem] font-medium w-full lg:w-auto overflow-x-auto pb-1 lg:pb-0 ${isMenuOpen ? 'flex flex-col items-start mt-4' : 'hidden'}`}>
          {navLinks.map((link) => (
            link.href.startsWith('#') || (isHome && link.href.startsWith('/#')) ? (
              <a 
                key={link.name} 
                href={link.href} 
                className="hover:text-aubergine whitespace-nowrap py-2 lg:py-0 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </a>
            ) : (
              <Link 
                key={link.name} 
                to={link.href} 
                className="hover:text-aubergine whitespace-nowrap py-2 lg:py-0 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </Link>
            )
          ))}
          <a 
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="lg:ml-4 px-6 py-2.5 bg-aubergine text-white rounded-xl font-bold text-sm hover:bg-aubergine-light transition-all text-center w-full lg:w-auto"
          >
            Download App
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;